export default __webpack_public_path__ + "static/media/bniaidja-color.60aea58c.svg";